const config = {
  LOCAL_STORAGE: {
    SECURITY_TOKEN: "auth_token",
  },
};
export default config;
